// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case_flow_audit {
  font-size: 12px !important;
  font-family: montserrat !important;
}

.tl-wrap:before {
  top: 15px;
  margin-left: -26px;
  width: 10px;
  height: 10px;
  border-color: orange;
  border-width: 3px;
  border-style: solid;
  background: orange;
  box-shadow: none;
}

.tl-wrap {
  display: block;
  margin-left: 6em;
  padding: 1px 0 7px 20px;
  border-style: solid;
  border-color: rgba(120, 130, 140, 0.13);
  border-width: 0 0 0 2px;
}

.header_box {
  background-color: #376B96;
  color: white;
  padding-block: 2%;
  padding-left: 4%;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  font-weight: 600;
}

.tl-date {
  top: 13px;
  margin-left: -8em;
  display: block;
  width: 4.5em;
  text-align: right;
}

.timeline_div {
  font-size: 10px;
  z-index: 9;
}

.dateValue {
  padding-inline: 2%;
  padding-top: 4%;
  border-right: 2px solid #376b96;
  font-weight: 600;
  font-size: 11px;
  width: 26%;
}

.selected_audit {
  background-color: rgba(109, 109, 194, 0.1607843137);
}

/* Timeline Container */
.timeline {
  background: var(--primary-color);
  margin: 10px auto;
  padding: 20px;
  font-family: montserrat !important;
}

.outer {
  display: flex;
  justify-content: center;
}

/* Card container */
.cards {
  position: relative;
  cursor: pointer;
  background-color: transparent;
  border: none;
  width: 152px;
  text-align: center;
  margin-left: -2px;
}

/* setting padding based on even or odd */
.cards:nth-child(odd) {
  padding: 27px 10px 30px 10px;
}
.cards:nth-child(odd) .tat_time {
  color: inherit;
  position: absolute;
  top: -10px;
  font-size: 10px;
  display: inherit;
  left: 25%;
}
.cards:nth-child(odd) .tat_time.dangers {
  color: #df2806;
}
.cards:nth-child(odd) .tat_time.inactive {
  color: grey;
}

.cards:nth-child(even) {
  padding: 27px 10px 30px 10px;
}
.cards:nth-child(even) .tat_time {
  position: absolute;
  font-size: 10px;
  display: inherit;
  left: 25%;
  bottom: -9px;
}
.cards:nth-child(even) .tat_time.dangers {
  color: #df2806;
}
.cards:nth-child(even) .tat_time.inactive {
  color: grey;
}

/* Global ::before */
.cards::before {
  content: "";
  position: absolute;
  width: 100%;
  border: solid #376b96;
}

.cards.dangers::before {
  content: "";
  position: absolute;
  width: 100%;
  border: solid #df2806;
  color: #df2806;
}

.cards.inactive::before {
  content: "";
  position: absolute;
  width: 100%;
  border: solid grey;
  opacity: 0.5;
  color: grey;
}

/* Setting the border of top, bottom, left */
.cards:nth-child(odd)::before {
  left: 1px;
  top: 16px;
  bottom: 47px;
  border-width: 2px 2px 0px 2px;
  border-radius: 30px 30px 1px 2px;
}

/* Setting the top and bottom to "-5px" because earlier it was out of a pixel in mobile devices */
@media only screen and (max-width: 400px) {
  .cards:nth-child(odd)::before {
    top: -5px;
    bottom: -5px;
  }
}
/* Setting the border of top, bottom, right */
.cards:nth-child(even)::before {
  left: 1px;
  top: 52px;
  bottom: 19px;
  border-width: 0px 2px 2px 2px;
  border-radius: 1px 2px 30px 30px;
}

/* Removing the border if it is the first card */
.cards:first-child::before {
  border-bottom: 0;
  border-bottom-left-radius: 0;
}

/* Removing the border if it is the last card  and it's odd */
.cards:last-child:nth-child(odd)::before {
  border-bottom: 0;
  border-bottom-left-radius: 0;
}

/* Removing the border if it is the last card  and it's even */
.cards:last-child:nth-child(even)::before {
  border-bottom-right-radius: 30px;
}

/* Information about the timeline */
.scale {
  font-family: montserrat !important;
  padding: 3px;
  height: 43px;
  width: 90%;
  border-radius: 34px;
  text-align: center;
  border: 2px solid #376b96;
  margin-inline: auto;
}
.scale .infos {
  display: flex;
  flex-direction: column;
  background: white;
  color: gray;
  padding: 3px;
  height: 33px;
  border-radius: 21px;
  text-align: center;
  border: 1px solid #376b96;
}
.scale .infos:hover, .scale .infos.active {
  cursor: pointer;
  background-color: #376b96;
}
.scale .infos:hover .title, .scale .infos.active .title {
  color: white;
  position: relative;
  margin: auto;
  font-weight: 600;
}

.scale.dangers {
  padding: 3px;
  height: 43px;
  width: 90%;
  border-radius: 34px;
  text-align: center;
  border: 2px solid #df2806;
  margin-inline: auto;
}
.scale.dangers .title {
  color: #df2806;
}
.scale.dangers .infos {
  display: flex;
  flex-direction: column;
  background: white;
  color: #df2806;
  padding: 3px;
  height: 33px;
  border-radius: 21px;
  text-align: center;
  border: 1px solid #df2806;
}
.scale.dangers .infos:hover, .scale.dangers .infos.active {
  cursor: pointer;
  background-color: #df2806;
}
.scale.dangers .infos:hover .title, .scale.dangers .infos.active .title {
  color: white;
  position: relative;
  margin: auto;
  font-weight: 600;
}

.scale.inactive {
  padding: 3px;
  height: 43px;
  width: 90%;
  border-radius: 34px;
  text-align: center;
  border: 2px solid grey;
  margin-inline: auto;
  opacity: 0.5;
}
.scale.inactive .title {
  color: grey;
}
.scale.inactive .infos {
  display: flex;
  flex-direction: column;
  background: white;
  color: grey;
  padding: 3px;
  height: 33px;
  border-radius: 21px;
  text-align: center;
  border: 1px solid grey;
}
.scale.inactive .infos:hover, .scale.inactive .infos.active {
  cursor: pointer;
  background-color: grey;
}
.scale.inactive .infos:hover .title, .scale.inactive .infos.active .title {
  color: white;
  position: relative;
  margin: auto;
  font-weight: 600;
}

/* Title of the card */
.title {
  color: #376b96;
  position: relative;
  margin: auto;
  font-weight: 600;
}

/* Timeline dot  */
.title::before {
  content: "";
  position: absolute;
  width: 3px;
  height: 3px;
  background-color: #376b96;
  border-radius: 999px;
  border: 3px solid #376b96;
}

.title.dangers::before {
  content: "";
  position: absolute;
  width: 3px;
  height: 3px;
  background-color: #df2806;
  border-radius: 999px;
  border: 3px solid #df2806;
}

.title.inactive::before {
  content: "";
  position: absolute;
  width: 3px;
  height: 3px;
  background-color: grey;
  border-radius: 999px;
  border: 3px solid grey;
  opacity: 0.5;
}

/* text right if the card is even  */
/* setting dot to the left if the card is odd */
.cards:nth-child(odd) > .scale > .infos > .title::before {
  left: 46%;
  top: -25px;
}

/* setting dot to the right if the card is odd */
.cards:nth-child(even) > .scale > .infos > .title::before {
  top: 38px;
  left: 50%;
}

.line_box {
  font-family: montserrat !important;
  display: flex;
  border-bottom: 2px solid orange;
  padding-bottom: 38px;
}

.text_circle {
  font-family: montserrat !important;
  flex: 1;
  text-align: center;
  position: relative;
}

.text_circle:after {
  background-color: #305e83;
  bottom: 1.25em;
  content: "";
  display: block;
  height: 2px;
  position: absolute;
  right: 0;
  width: 50%;
  z-index: -1;
}

.stav_projektu .text_circle:after,
.stav_projektu .text_circle:before {
  background-color: #305e83;
}

.line_box h4 {
  color: #376b96;
  font-weight: bold;
}

.line_box h4,
.line_box p {
  font-size: 12px;
  margin-bottom: 0;
  padding: 0 5px;
  position: relative;
  top: 54px;
}

.subline {
  position: absolute;
  right: -25px;
  top: 4px;
}

.subline:before {
  content: "";
  position: absolute;
  height: 10px;
  width: 10px;
  bottom: 14px;
  right: 15px;
  background-color: #FF9100;
  border-radius: 50%;
  top: 22px;
  left: 40%;
}

.subline h6 {
  margin-bottom: 0;
  color: orange;
  font-size: 10px !important;
  display: inherit;
  font-weight: 600;
}

.timeline {
  margin: 10px 0;
  box-shadow: 3px 1px 3px #305e83;
}

.text_circle.done:after,
.text_circle.done + .text_circle:before,
.stav_projektu .text_circle.done:after,
.stav_projektu .text_circle.done + .text_circle:before {
  background-color: #376b96;
}

.text_circle.sub:after {
  background-color: #376b96;
}

.text_circle:not(:first-child):before {
  bottom: 1.25em;
  content: "";
  display: block;
  height: 2px;
  position: absolute;
  left: 0;
  width: 50%;
  z-index: -1;
  background-color: #305e83;
}

.stav_projektu .text_circle:not(:first-child):before {
  background-color: #305e83;
}

.text_circle:last-child:after {
  width: 0;
}

.circle {
  height: 100%;
}

.tvar {
  height: 28px;
  width: 28px;
  display: flex;
  position: relative;
  border-radius: 100%;
  top: -34px;
  margin: 3px auto;
  background-color: #fff;
}

.tvar span {
  margin: auto;
  height: 20px;
  width: 20px;
  background-color: #376b96;
  border-radius: 100%;
  color: #fff;
}

.stav_projektu .tvar {
  border: 2px solid #305e83;
}

.stav_projektu .done .tvar,
.stav_projektu .sub .tvar {
  border: 2px solid #376b96;
}

.timeline .card-header:hover {
  background-color: #ececec;
  cursor: pointer;
}

/* iPhone X ----------------------------------- */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .subline:before {
    top: -43px;
  }
}
@media only screen and (device-width: 812px) and (device-height: 375px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .subline:before {
    top: -31px;
  }
}
/* iPad portrait ----------------------------------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .subline:before {
    top: -29px;
  }
}
/* mobile width till 767px ----------------------------------- */
@media (max-width: 767px) {
  .subline:before {
    top: -30px;
  }
}
/* Portrait iPad Pro */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  .subline:before {
    top: -23px;
  }
}
/* mobile width till 480px ----------------------------------- */
@media (max-width: 480px) {
  .subline:before {
    top: -43px;
  }
}
.stages_all {
  font-family: montserrat !important;
  display: flex;
  padding-bottom: 38px;
}
.stages_all .stage_data {
  font-family: montserrat !important;
  flex: 1;
  justify-content: center;
  display: inherit;
}

.showlabel {
  position: fixed;
  width: 41%;
  left: 5%;
}

.showAudit {
  position: fixed;
  z-index: 9;
  background-color: rgba(255, 255, 255, 0.6196078431);
  width: 100%;
}

.icon_copy_style {
  font-size: 14px;
  cursor: pointer;
  color: orange;
  height: 16px;
}

.text_flag {
  color: #376b96;
}`, "",{"version":3,"sources":["webpack://./src/app/case360/caseaudit/caseaudit.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,kCAAA;AACF;;AAIA;EACE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,uBAAA;AADF;;AAIA;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,+BAAA;EACA,gBAAA;AADF;;AAIA;EACE,SAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AADF;;AAIA;EACE,eAAA;EACA,UAAA;AADF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAAF;;AAGA;EACE,mDAAA;AAAF;;AAIA,uBAAA;AACA;EACE,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,kCAAA;AADF;;AAGA;EACE,aAAA;EACA,uBAAA;AAAF;;AAEA,mBAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA,yCAAA;AACA;EACE,4BAAA;AACF;AAAE;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAEJ;AAAE;EACE,cAAA;AAEJ;AAAE;EACE,WAAA;AAEJ;;AACA;EACE,4BAAA;AAEF;AADE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;AAGJ;AAAE;EACE,cAAA;AAEJ;AAAE;EACE,WAAA;AAEJ;;AACA,oBAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AAEF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA,4CAAA;AACA;EACE,SAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,gCAAA;AACF;;AAEA,iGAAA;AACA;EACE;IACE,SAAA;IACA,YAAA;EACF;AACF;AAEA,6CAAA;AACA;EACE,SAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,gCAAA;AAAF;;AAGA,gDAAA;AACA;EACE,gBAAA;EACA,4BAAA;AAAF;;AAGA,6DAAA;AACA;EACE,gBAAA;EACA,4BAAA;AAAF;;AAGA,8DAAA;AACA;EAEE,gCAAA;AADF;;AAIA,mCAAA;AAEA;EACE,kCAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAFF;AAGE;EACK,aAAA;EACH,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AADJ;AAEI;EACE,eAAA;EACA,yBAAA;AAAN;AACM;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACJ,gBAAA;AACJ;;AAMA;EACE,YAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAHF;AAIE;EACE,cAAA;AAFJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAFJ;AAGI;EACE,eAAA;EACA,yBAAA;AADN;AAEM;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACJ,gBAAA;AAAJ;;AAQA;EACE,YAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AALF;AAME;EACE,WAAA;AAJJ;AAME;EAEE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AALJ;AAMI;EACE,eAAA;EACA,sBAAA;AAJN;AAKM;EACE,YAAA;EACA,kBAAA;EACN,YAAA;EACA,gBAAA;AAHF;;AAUA,sBAAA;AACA;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAPF;;AAWA,kBAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,yBAAA;AARF;;AAYA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,yBAAA;AATF;;AAYA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,YAAA;AATF;;AAYA,oCAAA;AAEA,+CAAA;AACA;EACE,SAAA;EACA,UAAA;AAVF;;AAaA,gDAAA;AACA;EACE,SAAA;EACA,SAAA;AAVF;;AAaA;EACE,kCAAA;EACA,aAAA;EACA,+BAAA;EACA,oBAAA;AAVF;;AAYA;EACE,kCAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;AATF;;AAWA;EACE,yBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AARF;;AAUA;;EAEE,yBAAA;AAPF;;AASA;EACE,cAAA;EACA,iBAAA;AANF;;AAQA;;EAEE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AALF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;AAJF;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AAJF;;AAMA;EACE,gBAAA;EACA,aAAA;EACE,0BAAA;EACA,gBAAA;EACA,gBAAA;AAHJ;;AAKA;EACE,cAAA;EACA,+BAAA;AAFF;;AAIA;;;;EAIE,yBAAA;AADF;;AAGA;EACE,yBAAA;AAAF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AACF;;AACA;EACE,yBAAA;AAEF;;AAAA;EACE,QAAA;AAGF;;AADA;EACE,YAAA;AAIF;;AAFA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;AAKF;;AAHA;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAMF;;AAJA;EACE,yBAAA;AAOF;;AALA;;EAEE,yBAAA;AAQF;;AALA;EACE,yBAAA;EACA,eAAA;AAQF;;AANA,iDAAA;AACA;EACE;IACE,UAAA;EASF;AACF;AAPA;EACE;IACE,UAAA;EASF;AACF;AAPA,sDAAA;AACA;EACE;IACE,UAAA;EASF;AACF;AAPA,gEAAA;AACA;EACE;IACE,UAAA;EASF;AACF;AAPA,sBAAA;AACA;EACE;IACE,UAAA;EASF;AACF;AAPA,gEAAA;AACA;EACE;IACE,UAAA;EASF;AACF;AANA;EACE,kCAAA;EACA,aAAA;EACA,oBAAA;AAQF;AAPE;EACE,kCAAA;EACE,OAAA;EACA,uBAAA;EACA,gBAAA;AASN;;AAHA;EACE,eAAA;EACA,UAAA;EACA,QAAA;AAMF;;AAJA;EACC,eAAA;EAAgB,UAAA;EAAW,mDAAA;EAC3B,WAAA;AASD;;AANA;EACE,eAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AASF;;AANA;EACE,cAAA;AASF","sourcesContent":[".case_flow_audit{\r\n  font-size: 12px !important;\r\n  font-family: montserrat !important;\r\n}\r\n\r\n\r\n\r\n.tl-wrap:before {\r\n  top: 15px;\r\n  margin-left: -26px;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-color: orange;\r\n  border-width: 3px;\r\n  border-style: solid;\r\n  background: orange;\r\n  box-shadow: none;\r\n}\r\n\r\n.tl-wrap {\r\n  display: block;\r\n  margin-left: 6em;\r\n  padding: 1px 0 7px 20px;;\r\n  border-style: solid;\r\n  border-color: rgba(120, 130, 140, .13);\r\n  border-width: 0 0 0 2px;\r\n}\r\n\r\n.header_box{\r\n  background-color: #376B96;\r\n  color: white;\r\n  padding-block: 2%;\r\n  padding-left: 4%;\r\n  border-top-right-radius: 2px;\r\n  border-bottom-right-radius: 2px;\r\n  font-weight: 600;\r\n}\r\n\r\n.tl-date {\r\n  top: 13px;\r\n  margin-left: -8em;\r\n  display: block;\r\n  width: 4.5em;\r\n  text-align: right;\r\n}\r\n\r\n.timeline_div{\r\n  font-size: 10px;\r\n  z-index: 9;\r\n}\r\n.dateValue{\r\n  padding-inline: 2%;\r\n  padding-top: 4%;\r\n  border-right: 2px solid #376b96;\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  width: 26%;\r\n}\r\n\r\n.selected_audit{\r\n  background-color: #6d6dc229;\r\n}\r\n\r\n\r\n/* Timeline Container */\r\n.timeline {\r\n  background: var(--primary-color);\r\n  margin: 10px auto;\r\n  padding: 20px;\r\n  font-family: montserrat !important;\r\n}\r\n.outer {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n/* Card container */\r\n.cards {\r\n  position: relative;\r\n  cursor: pointer;\r\n  background-color: transparent;\r\n  border: none;\r\n  width: 152px;\r\n  text-align: center;\r\n  margin-left: -2px;\r\n}\r\n\r\n/* setting padding based on even or odd */\r\n.cards:nth-child(odd) {\r\n  padding: 27px 10px 30px 10px;\r\n  .tat_time {\r\n    color: inherit;\r\n    position: absolute;\r\n    top: -10px;\r\n    font-size: 10px;\r\n    display: inherit;\r\n    left: 25%;\r\n  }\r\n  .tat_time.dangers{\r\n    color:#df2806\r\n  }\r\n  .tat_time.inactive{\r\n    color:grey\r\n  }\r\n}\r\n.cards:nth-child(even) {\r\n  padding:27px 10px 30px 10px;\r\n  .tat_time {\r\n    position: absolute;\r\n    font-size: 10px;\r\n    display: inherit;\r\n    left: 25%;\r\n    bottom: -9px;\r\n\r\n  }\r\n  .tat_time.dangers{\r\n    color:#df2806\r\n  }\r\n  .tat_time.inactive{\r\n    color:grey\r\n  }\r\n}\r\n/* Global ::before */\r\n.cards::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 100%;\r\n  border: solid #376b96;\r\n}\r\n\r\n// dangers\r\n.cards.dangers::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 100%;\r\n  border: solid #df2806;\r\n  color:  #df2806;\r\n}\r\n// inactive\r\n.cards.inactive::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 100%;\r\n  border: solid grey;\r\n  opacity: 0.5;\r\n  color:grey ;\r\n}\r\n\r\n/* Setting the border of top, bottom, left */\r\n.cards:nth-child(odd)::before {\r\n  left: 1px;\r\n  top: 16px;\r\n  bottom: 47px;\r\n  border-width: 2px 2px 0px 2px;\r\n  border-radius: 30px 30px 1px 2px;\r\n}\r\n\r\n/* Setting the top and bottom to \"-5px\" because earlier it was out of a pixel in mobile devices */\r\n@media only screen and (max-width: 400px) {\r\n  .cards:nth-child(odd)::before {\r\n    top: -5px;\r\n    bottom: -5px;\r\n  }\r\n}\r\n\r\n/* Setting the border of top, bottom, right */\r\n.cards:nth-child(even)::before {\r\n  left: 1px;\r\n  top: 52px;\r\n  bottom: 19px;\r\n  border-width: 0px 2px 2px 2px;\r\n  border-radius: 1px 2px 30px 30px;\r\n}\r\n\r\n/* Removing the border if it is the first card */\r\n.cards:first-child::before {\r\n  border-bottom: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n/* Removing the border if it is the last card  and it's odd */\r\n.cards:last-child:nth-child(odd)::before {\r\n  border-bottom: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n/* Removing the border if it is the last card  and it's even */\r\n.cards:last-child:nth-child(even)::before {\r\n  // border-bottom: 0;\r\n  border-bottom-right-radius: 30px;\r\n}\r\n\r\n/* Information about the timeline */\r\n\r\n.scale {\r\n  font-family: montserrat !important;\r\n  padding: 3px;\r\n  height: 43px;\r\n  width: 90%;\r\n  border-radius: 34px;\r\n  text-align: center;\r\n  border: 2px solid #376b96;\r\n  margin-inline: auto;\r\n  .infos {\r\n       display: flex;\r\n    flex-direction: column;\r\n    background: white;\r\n    color: gray;\r\n    padding: 3px;\r\n    height: 33px;\r\n    border-radius: 21px;\r\n    text-align: center;\r\n    border: 1px solid #376b96;\r\n    &:hover,&.active {\r\n      cursor: pointer;\r\n      background-color: #376b96;\r\n      .title {\r\n        color: white;\r\n        position: relative;\r\n        margin: auto;\r\n    font-weight: 600;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// falied\r\n.scale.dangers {\r\n  padding: 3px;\r\n  height: 43px;\r\n  width: 90%;\r\n  border-radius: 34px;\r\n  text-align: center;\r\n  border: 2px solid #df2806;\r\n  margin-inline: auto;\r\n  .title {\r\n    color: #df2806;\r\n  }\r\n  .infos {\r\n    display: flex;\r\n    flex-direction: column;\r\n    background: white;\r\n    color: #df2806;\r\n    padding: 3px;\r\n    height: 33px;\r\n    border-radius: 21px;\r\n    text-align: center;\r\n    border: 1px solid #df2806;\r\n    &:hover,&.active {\r\n      cursor: pointer;\r\n      background-color: #df2806;\r\n      .title {\r\n        color: white;\r\n        position: relative;\r\n        margin: auto;\r\n    font-weight: 600;\r\n\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// inactive\r\n.scale.inactive {\r\n  padding: 3px;\r\n  height: 43px;\r\n  width: 90%;\r\n  border-radius: 34px;\r\n  text-align: center;\r\n  border: 2px solid grey;\r\n  margin-inline: auto;\r\n  opacity: 0.5;\r\n  .title {\r\n    color: grey;\r\n  }\r\n  .infos {\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    background: white;\r\n    color: grey;\r\n    padding: 3px;\r\n    height: 33px;\r\n    border-radius: 21px;\r\n    text-align: center;\r\n    border: 1px solid grey;\r\n    &:hover,&.active {\r\n      cursor: pointer;\r\n      background-color: grey;\r\n      .title {\r\n        color: white;\r\n        position: relative;\r\n  margin: auto;\r\n  font-weight: 600;\r\n\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* Title of the card */\r\n.title {\r\n  color: #376b96;\r\n  position: relative;\r\n  margin: auto;\r\n  font-weight: 600;\r\n\r\n}\r\n\r\n/* Timeline dot  */\r\n.title::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 3px;\r\n  height: 3px;\r\n  background-color: #376b96;\r\n  border-radius: 999px;\r\n  border: 3px solid #376b96;\r\n}\r\n\r\n// failed\r\n.title.dangers::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 3px;\r\n  height: 3px;\r\n  background-color: #df2806;\r\n  border-radius: 999px;\r\n  border: 3px solid #df2806;\r\n}\r\n// inactive\r\n.title.inactive::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 3px;\r\n  height: 3px;\r\n  background-color: grey;\r\n  border-radius: 999px;\r\n  border: 3px solid grey;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* text right if the card is even  */\r\n\r\n/* setting dot to the left if the card is odd */\r\n.cards:nth-child(odd) > .scale > .infos > .title::before {\r\n  left: 46%;\r\n  top: -25px;\r\n}\r\n\r\n/* setting dot to the right if the card is odd */\r\n.cards:nth-child(even) > .scale > .infos > .title::before {\r\n  top: 38px;\r\n  left: 50%;\r\n}\r\n\r\n.line_box {\r\n  font-family: montserrat !important;\r\n  display: flex;\r\n  border-bottom: 2px solid orange;\r\n  padding-bottom: 38px;\r\n}\r\n.text_circle {\r\n  font-family: montserrat !important;\r\n  flex: 1;\r\n  text-align: center;\r\n  position: relative;\r\n}\r\n.text_circle:after {\r\n  background-color: #305e83;\r\n  bottom: 1.25em;\r\n  content: \"\";\r\n  display: block;\r\n  height: 2px;\r\n  position: absolute;\r\n  right: 0;\r\n  width: 50%;\r\n  z-index: -1;\r\n}\r\n.stav_projektu .text_circle:after,\r\n.stav_projektu .text_circle:before {\r\n  background-color: #305e83;\r\n}\r\n.line_box h4 {\r\n  color: #376b96;\r\n  font-weight: bold;\r\n}\r\n.line_box h4,\r\n.line_box p {\r\n  font-size: 12px;\r\n  margin-bottom: 0;\r\n  padding: 0 5px;\r\n  position: relative;\r\n  top: 54px;\r\n}\r\n.subline {\r\n  position: absolute;\r\n  right: -25px;\r\n  top: 4px;\r\n  // bottom: -43%;\r\n}\r\n.subline:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 10px;\r\n  width: 10px;\r\n  bottom: 14px;\r\n  right: 15px;\r\n  background-color: #FF9100;\r\n  border-radius: 50%;\r\n  top: 22px;\r\n  left: 40%;\r\n}\r\n.subline h6 {\r\n  margin-bottom: 0;\r\n  color: orange;\r\n    font-size: 10px !important;\r\n    display: inherit;\r\n    font-weight: 600;\r\n}\r\n.timeline {\r\n  margin: 10px 0;\r\n  box-shadow: 3px 1px 3px #305e83;\r\n}\r\n.text_circle.done:after,\r\n.text_circle.done + .text_circle:before,\r\n.stav_projektu .text_circle.done:after,\r\n.stav_projektu .text_circle.done + .text_circle:before {\r\n  background-color: #376b96;\r\n}\r\n.text_circle.sub:after {\r\n  background-color: #376b96;\r\n}\r\n.text_circle:not(:first-child):before {\r\n  bottom: 1.25em;\r\n  content: \"\";\r\n  display: block;\r\n  height: 2px;\r\n  position: absolute;\r\n  left: 0;\r\n  width: 50%;\r\n  z-index: -1;\r\n  background-color: #305e83;\r\n}\r\n.stav_projektu .text_circle:not(:first-child):before {\r\n  background-color: #305e83;\r\n}\r\n.text_circle:last-child:after {\r\n  width: 0;\r\n}\r\n.circle {\r\n  height: 100%;\r\n}\r\n.tvar {\r\n  height: 28px;\r\n  width: 28px;\r\n  display: flex;\r\n  position: relative;\r\n  border-radius: 100%;\r\n  top: -34px;\r\n  margin: 3px auto;\r\n  background-color: #fff;\r\n}\r\n.tvar span {\r\n  margin:auto;\r\n  height: 20px;\r\n  width: 20px;\r\n  background-color: #376b96;\r\n  border-radius: 100%;\r\n  color: #fff;\r\n}\r\n.stav_projektu .tvar {\r\n  border: 2px solid #305e83;\r\n}\r\n.stav_projektu .done .tvar,\r\n.stav_projektu .sub .tvar {\r\n  border: 2px solid #376b96;\r\n}\r\n\r\n.timeline .card-header:hover {\r\n  background-color: #ececec;\r\n  cursor: pointer;\r\n}\r\n/* iPhone X ----------------------------------- */\r\n@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {\r\n  .subline:before {\r\n    top: -43px;\r\n  }\r\n}\r\n@media only screen and (device-width: 812px) and (device-height: 375px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {\r\n  .subline:before {\r\n    top: -31px;\r\n  }\r\n}\r\n/* iPad portrait ----------------------------------- */\r\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\r\n  .subline:before {\r\n    top: -29px;\r\n  }\r\n}\r\n/* mobile width till 767px ----------------------------------- */\r\n@media (max-width: 767px) {\r\n  .subline:before {\r\n    top: -30px;\r\n  }\r\n}\r\n/* Portrait iPad Pro */\r\n@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {\r\n  .subline:before {\r\n    top: -23px;\r\n  }\r\n}\r\n/* mobile width till 480px ----------------------------------- */\r\n@media (max-width: 480px) {\r\n  .subline:before {\r\n    top: -43px;\r\n  }\r\n}\r\n\r\n.stages_all{\r\n  font-family: montserrat !important;\r\n  display: flex;\r\n  padding-bottom: 38px;\r\n  .stage_data{\r\n    font-family: montserrat !important;\r\n      flex: 1;\r\n      justify-content: center;\r\n      display: inherit;\r\n\r\n  }\r\n}\r\n\r\n\r\n.showlabel{\r\n  position: fixed;\r\n  width: 41%;\r\n  left: 5%;\r\n}\r\n.showAudit{\r\n position: fixed;z-index: 9;background-color: #ffffff9e;\r\n width: 100%;\r\n}\r\n\r\n.icon_copy_style{\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  color: orange;\r\n  height: 16px;\r\n}\r\n\r\n.text_flag{\r\n  color: #376b96;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
